const widgetExport = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M12.609 9.108H14V14H2V9.108h1.371l.003 3.423h9.234zM7.3 5.68H4.46L8 2l3.54 3.681H8.7v5.372H7.3z"/></svg>',
};

export { widgetExport as default };
